import { ChangeDetectionStrategy, Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogResult } from 'src/app/models/dialog-result';
import {
  IProductRef,
  ITouchMapping,
  ITransferDestination,
  ITransferPrepareResult,
  ITransferSource,
} from 'src/app/models/products/actions/settings/transferProductSettings';
import { ProductsService } from 'src/app/services/products.service';

export interface MapTouchesStepData {
  source: ITransferSource;
  destination: ITransferDestination;
  products: IProductRef[];
}

export interface MapTouchesStepResult {
  touchMappings: ITouchMapping[];
  prepareResult: ITransferPrepareResult;
}

@Component({
  selector: 'app-map-touches-step',
  templateUrl: './map-touches-step.component.html',
  styleUrls: ['./map-touches-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class MapTouchesStepComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  prepareResult: ITransferPrepareResult | null = null;
  touchMappings: ITouchMapping[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MapTouchesStepData,
    private readonly dialogRef: MatDialogRef<MapTouchesStepComponent>,
    private readonly productsService: ProductsService,
  ) {}

  ngOnInit(): void {
    this.productsService
      .prepareProductSettingsTransfer({
        source: this.data.source,
        destination: this.data.destination,
        products: this.data.products,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.prepareResult = result;
      });
  }

  onMappingsChanged(mappings: ITouchMapping[]): void {
    this.touchMappings = mappings;
  }

  get sourceMasterSuiteName(): string {
    return this.prepareResult?.masterSuiteSource.name ?? '';
  }

  get destinationMasterSuiteName(): string {
    return this.prepareResult?.masterSuiteDestination.name ?? '';
  }

  confirm(): void {
    if (!this.prepareResult) return;
    this.dialogRef.close({
      touchMappings: this.touchMappings,
      prepareResult: this.prepareResult,
    } as MapTouchesStepResult);
  }

  cancel(): void {
    this.dialogRef.close(DialogResult.Cancel);
  }
}
